<template>
    <!-- Portfolio section start -->
	<section id="portfolio-section" class="px-4 lg:px-8 py-16 relative">
        <!-- Text wrapper start -->
        <div class="flex gap-8 flex-col md:flex-row">
            <!-- Main text start -->
            <h1 class="uppercase text-5xl mb-4 font-semibold ">
                PRODUCTOS
            </h1>
            <p class="capitalize xl:w-1/2 text-stone-500 mb-8">
                "Transformamos ideas en innovación, incluso cuando los proyectos son pocos. ¡Descubre lo que podemos crear juntos!"
            </p>
            <!-- Main text end -->
        </div>
        <!-- Text wrapper end -->

        <!-- Kordo start -->
        <div class="grid grid-cols-1 md:grid-cols-2 w-full mb-16">
            <div class="hidden md:flex justify-center items-center">
                <img src="@/assets/kordo.png" alt="">
            </div>
            <div class="flex flex-col w-full items-center">
                <p class="capitalize xl:w-1/2 text-stone-500 mb-8">
                    "Kordo: Tu socio en la gestión de procesos. Nuestro software, el gestor de procesos que pertenece a todos los negocios, te brinda trazabilidad total y un registro detallado en cada paso, impulsando la eficiencia y el control en tu empresa."
                </p>
                <a href="https://kordo.koherencia.com.co/" target="_blank">
                    <button class="btn w-full">Conoce Kordo</button>
                </a>
            </div>
        </div>
        <!-- Kordo end -->

        <!-- Divider -->
        <div class="border-t border-stone-200 mb-16"></div>

        <!-- AI Agent start -->
        <div class="grid grid-cols-1 md:grid-cols-2 w-full gap-8 items-center">
            <div class="flex flex-col justify-center px-4 md:px-8">
                <h2 class="uppercase text-3xl font-semibold mb-4">
                    Agente IA para agendas médicas
                </h2>
                <p class="text-stone-500 mb-6">
                    Un asistente inteligente que gestiona citas médicas a través de WhatsApp, disponible las 24 horas. Elimina llamadas, reduce inasistencias y libera tiempo del equipo médico desde el primer día.
                </p>

                <!-- Roles -->
                <div class="flex flex-col sm:flex-row gap-4 mb-6">
                    <div class="flex-1 bg-stone-50 rounded-xl p-4">
                        <div class="flex items-center gap-2 mb-3">
                            <i class="fa-solid fa-user text-stone-400 text-sm"></i>
                            <span class="uppercase text-xs font-semibold tracking-widest text-stone-500">Pacientes</span>
                        </div>
                        <ul class="space-y-2">
                            <li class="flex items-start gap-2 text-sm text-stone-600">
                                <i class="fa-solid fa-check text-stone-400 mt-0.5 shrink-0"></i>
                                <span>Agenda y cancela citas por WhatsApp</span>
                            </li>
                            <li class="flex items-start gap-2 text-sm text-stone-600">
                                <i class="fa-solid fa-check text-stone-400 mt-0.5 shrink-0"></i>
                                <span>Recordatorios automáticos</span>
                            </li>
                            <li class="flex items-start gap-2 text-sm text-stone-600">
                                <i class="fa-solid fa-check text-stone-400 mt-0.5 shrink-0"></i>
                                <span>Gestión de pacientes a cargo</span>
                            </li>
                        </ul>
                    </div>
                    <div class="flex-1 bg-stone-50 rounded-xl p-4">
                        <div class="flex items-center gap-2 mb-3">
                            <i class="fa-solid fa-stethoscope text-stone-400 text-sm"></i>
                            <span class="uppercase text-xs font-semibold tracking-widest text-stone-500">Médicos</span>
                        </div>
                        <ul class="space-y-2">
                            <li class="flex items-start gap-2 text-sm text-stone-600">
                                <i class="fa-solid fa-check text-stone-400 mt-0.5 shrink-0"></i>
                                <span>Control total de la agenda</span>
                            </li>
                            <li class="flex items-start gap-2 text-sm text-stone-600">
                                <i class="fa-solid fa-check text-stone-400 mt-0.5 shrink-0"></i>
                                <span>Gestión desde WhatsApp</span>
                            </li>
                            <li class="flex items-start gap-2 text-sm text-stone-600">
                                <i class="fa-solid fa-check text-stone-400 mt-0.5 shrink-0"></i>
                                <span>Menos carga administrativa</span>
                            </li>
                        </ul>
                    </div>
                </div>

                <a href="https://docagent.koherencia.com.co/registro" target="_blank">
                    <button class="btn w-full md:w-auto">Conoce el Agente</button>
                </a>
            </div>

            <!-- Logo -->
            <div class="flex justify-center items-center order-first md:order-last">
                <img src="@/assets/services/ai-agenda-logo.png" alt="Agente IA para agendas médicas" class="w-64 h-64 object-contain grayscale">
            </div>
        </div>
        <!-- AI Agent end -->

        <!-- Circle start -->
        <div class="bg-neutral-300 h-64 w-64 rounded-full absolute top-0 left-0 mt-16 -z-20"></div>
        <!-- Circle end -->
	</section>
	<!-- Portfolio section end -->
</template>

<script>
export default {

}
</script>

<style>

</style>
